export class Exporter {
  export(format, documentModel, options = {}) {
    if (format === "json") {
      return JSON.stringify(withCoordinateMetadata(documentModel, options.coordinates), null, 2);
    }

    throw new Error(`Unsupported export format: ${format}`);
  }
}

function withCoordinateMetadata(documentModel, coordinates) {
  if (!coordinates) {
    return documentModel;
  }

  return {
    ...documentModel,
    metadata: {
      ...(documentModel.metadata ?? {}),
      coordinates: { ...coordinates }
    }
  };
}
